import React, { Component } from 'react';
import { Divider, HTMLTable, Tag, Intent } from '@blueprintjs/core';
import SideMenuWrapper from '../Components/SideMenuWrapper';

export default class Gateways extends Component {
  constructor(props) {
    super(props);
    this.state = {
      gateways: [
        { name: 'Gateway Server #1 (Primary)', ip: '127.0.0.1', port: 15884, load: '1.2%', status: 'ONLINE' },
        { name: 'Gateway Server #2 (Backup)', ip: '127.0.0.1', port: 15885, load: '0.4%', status: 'ONLINE' },
      ]
    };
  }

  render() {
    return (
      <SideMenuWrapper>
        <h3 className="display-4 font-italic mb-3" style={{ fontSize: '1.5rem', color: '#182026' }}>
          Gateway Servers & Load Balancing
        </h3>
        <p className="text-muted mb-3" style={{ fontSize: '0.85rem' }}>
          Configure Silkroad Gateway nodes, port forwarding, and DDoS packet filters.
        </p>

        <Divider className="mb-4" />

        <HTMLTable bordered condensed striped style={{ width: '100%', fontSize: '0.82rem' }}>
          <thead>
            <tr>
              <th style={{ color: '#182026' }}>Gateway Node</th>
              <th style={{ color: '#182026' }}>IP Address</th>
              <th style={{ color: '#182026' }}>Listen Port</th>
              <th style={{ color: '#182026' }}>CPU Load</th>
              <th style={{ color: '#182026' }}>Status</th>
            </tr>
          </thead>
          <tbody>
            {this.state.gateways.map((g, i) => (
              <tr key={i}>
                <td className="font-weight-bold" style={{ color: '#182026' }}>{g.name}</td>
                <td className="font-mono" style={{ color: '#5c7080' }}>{g.ip}</td>
                <td className="font-mono text-warning font-weight-bold">{g.port}</td>
                <td className="font-mono text-info font-weight-bold">{g.load}</td>
                <td><Tag intent={Intent.SUCCESS} round>{g.status}</Tag></td>
              </tr>
            ))}
          </tbody>
        </HTMLTable>
      </SideMenuWrapper>
    );
  }
}
